import FullWidthBorderSlider from 'components/FullWidthBorderSlider'
import { graphql, useStaticQuery } from 'gatsby'
import { useBreakpoint } from 'gatsby-plugin-breakpoints'
import React, { useRef, useState } from 'react'

export function TutorialsSlider({ topic, slugs, allTutorialsSlider }: { topic?: string; slugs?: string[] }): any {
    let topicIn = allTutorialsSlider?.topic
    if (Array.isArray(topic) && topic?.length == 1) topicIn = topicIn[0]
    const slugsIn = allTutorialsSlider?.slugs
    const topicInput = topic || topicIn
    const slugsInput = slugs || slugsIn
    const tutorialsSliderTitle = allTutorialsSlider?.tutorialsSliderTitle
    const title = tutorialsSliderTitle?.title
    const subtitle = tutorialsSliderTitle?.subtitle
    const {
        allMdx: { nodes },
    } = useStaticQuery(query)
    const tutorials = nodes?.filter((tutorial) => {
        return slugsInput
            ? slugsInput?.includes(tutorial?.fields?.slug)
            : tutorial?.frontmatter?.tags?.some((tutorialTag) => tutorialTag === topicInput)
    })
    const [activeSlide, setActiveSlide] = useState(0)
    // console.log(`allTutorialsSlider ${JSON.stringify(allTutorialsSlider)}`)
    return (
        <>
            {title && <h3 className="mb-0">{title}</h3>}
            {subtitle && <p>{subtitle}</p>}
            <FullWidthBorderSlider
                setActiveSlide={setActiveSlide}
                activeSlide={activeSlide}
                slides={tutorials?.map((tutorial) => {
                    const featuredImage = tutorial?.frontmatter?.featuredImage
                    const authors = tutorial?.frontmatter?.authors || tutorial?.frontmatter?.authors2
                    const title = tutorial?.frontmatter?.title
                    const date = tutorial?.parent?.date
                    const id = tutorial?.id
                    const slug = tutorial?.fields?.slug
                    return {
                        image: featuredImage,
                        authors,
                        title,
                        date,
                        url: slug,
                        id,
                    }
                })}
            />
        </>
    )
}

export const query = graphql`
    query TutorialsSliderQuery {
        allMdx(filter: { fields: { slug: { regex: "/^/tutorials/" } } }, limit: 1000) {
            nodes {
                id
                fields {
                    slug
                }
                frontmatter {
                    title
                    tags
                    authors: authorData {
                        frontmatter {
                            handle
                            link_type
                            name
                            link_url
                            role: jobTitle
                            image {
                                childrenImageSharp {
                                    gatsbyImageData(width: 36, height: 36)
                                }
                            }
                        }
                        id
                        name
                        parent {
                            ... on GoogleDocs {
                                cover {
                                    image {
                                        publicURL
                                        childImageSharp {
                                            gatsbyImageData(width: 36, height: 36)
                                        }
                                    }
                                }
                            }
                        }
                    }
                    authors2: authorData2 {
                        id
                        image {
                            childImageSharp {
                                gatsbyImageData(width: 36, height: 36)
                            }
                        }
                        name
                    }
                    featuredImage {
                        childImageSharp {
                            gatsbyImageData(width: 514, height: 289)
                        }
                    }
                }
                parent {
                    ... on File {
                        fields {
                            date: gitLogLatestDate
                        }
                    }
                }
            }
        }
    }
`
export default TutorialsSlider
